/**
 * This is the initial state of our app.
 *
 * Here we can read the state from the localStorage to initializa it.
 *
 */
import userHandler from "./utils/userHandler";
import { IStore } from "./store";
import { default as StoreModel } from "./store/StoreModel";
import { active, Configurations, getConfig } from "./config";

const user = userHandler.getUser();
const config =
  user && user.environment
    ? getConfig(user.environment)
    : Configurations[active];

const initialState: IStore = {
  auth: {
    user: user,
    token: userHandler.getToken(),
    request: StoreModel.defaultSingle(),
  },
  notification: {
    visible: false,
  },
  race: {
    resume: StoreModel.default(),
    byState: {},
    current: StoreModel.defaultSingle(),
    byId: {},
    all: StoreModel.default(),
  },
  client: { data: StoreModel.default(), save: StoreModel.defaultSingle() },
  driver: {
    data: StoreModel.default(),
    abm: StoreModel.defaultSingle(),
    disable: StoreModel.defaultSingle(),
    activate: StoreModel.defaultSingle(),
    locations: StoreModel.default(),
    locationById: {},
  },
  admin: {
    data: { fetching: false },
    add: { fetching: false },
    disable: { fetching: false },
    activate: { fetching: false },
  },
  fcm: { send: { fetching: false } },

  company: {
    data: StoreModel.default(),
    add: StoreModel.defaultSingle(),
  },

  order: {
    data: StoreModel.default(),
  },

  category: {
    data: StoreModel.default(),
    abm: StoreModel.defaultSingle(),
    disable: StoreModel.defaultSingle(),
  },

  branch: { data: { fetching: false }, add: { fetching: false } },

  product: {
    data: StoreModel.default(),
    abm: StoreModel.defaultSingle(),
    disable: StoreModel.defaultSingle(),
  },

  config: {
    data: config,
    active: active,
    debug: true,
    availables: Object.keys(Configurations).map(
      (configKey) => Configurations[configKey].name
    ),
  },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/initialState.ts